
@if (properties()) {
  <div class="pl-3 pr-2">
    <swiper-container #swiperRef [slidesPerView]="slidesPerView" navigation-next-el=".swiper-button-next+{{id()}}" navigation-prev-el=".swiper-button-prev+{{id()}}" center-insufficient-slides="true" rewind="true">
      @for (property of properties(); track property) {
        <swiper-slide class="swiper-slide">
          <app-property-item [property]="property" [viewType]="'grid'" (propertyItemClicked)="onPropertyItemClicked(property)"></app-property-item>
        </swiper-slide>
      }
    </swiper-container>
    <div [hidden]="properties().length<=slidesPerView" [class]="'swiper-button-prev'+id()" (click)="swipePrev()">&lt;</div>
    <div [hidden]="properties().length<=slidesPerView" [class]="'swiper-button-next'+id()" (click)="swipeNext()">&gt;</div>
  </div>
}